import React from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import generalUtil from "../../../utils/generalUtils";
import Typography from "@mui/material/Typography";
import Rating from "@mui/material/Rating";
import { Link, Script } from "gatsby";

const RelatedProducts = ({ strapiArticle, productsArray }) => {
  const sponsorListings = generateSponsors(strapiArticle.subCategoryTags);
  const relatedListings = generateListings(strapiArticle, productsArray);
  const alalyticsProds = analProds(relatedListings);
  const alalyticsPromos = analPromos(relatedListings);
  const isBrowser = typeof window !== "undefined";

  function generateSponsors(subCats) {
    let sponsors = [];
    subCats.forEach(function (subCat) {
      if (subCat.sponsoredListing) {
        let sponsoredListing = subCat.sponsoredListing;
        if (
          sponsors.find(
            (element) => element.strapi_id === sponsoredListing.strapi_id
          )
        ) {
        } else {
          sponsoredListing["sponsored"] = true;
          sponsors.push(sponsoredListing);
        }
      }
    });
    return sponsors;
  }

  function analProds(sideBarProducts) {
    let analObjects = [];
    let organicIndex = 0;
    sideBarProducts.forEach((listing, index) => {
      let analObj = {};
      analObj["item_id"] = "P" + listing.strapi_id; // unique identifier for a product apart from the name
      analObj["item_name"] = listing.name; //Name of the vendor //Cat name
      analObj["item_list_name"] = "Article"; //What is the category page where this impressions loads
      analObj["indexOverall"] = index; //what is the position of that vendor on that list
      analObj["index"] = organicIndex; //what is the position of that vendor on that list
      analObj["productIndex"] = organicIndex;
      analObj["brand"] = listing.companyName; //Name of the brand
      if (!listing.sponsored) {
        organicIndex += 1;
        analObjects.push(analObj);
      }
    });
    return analObjects;
  }

  function analPromos(sideBarProducts) {
    let analObjects = [];
    let organicIndex = 0;
    sideBarProducts.forEach((listing, index) => {
      let analObj = {};
      analObj["item_id"] = "P" + listing.strapi_id; // unique identifier for a product apart from the name
      analObj["item_name"] = listing.name; //Name of the vendor //Cat name
      analObj["item_list_name"] = "Article"; //What is the category page where this impressions loads
      analObj["indexOverall"] = index; //what is the position of that vendor on that list
      analObj["index"] = organicIndex;
      analObj["productIndex"] = organicIndex;
      analObj["brand"] = listing.companyName; //Name of the brand
      if (listing.sponsored) {
        organicIndex += 1;
        analObjects.push(analObj);
      }
    });
    return analObjects;
  }

  function generateListings(articleData, allListings) {
    let listingsArray = [];
    let idArray = [];
    articleData.subCategoryTags.forEach(function (tag) {
      idArray.push(tag.strapi_id);
    });
    listingsArray = allListings.filter((listing) =>
      idArray.includes(listing.primaryProductSubCategory.strapi_id)
    );
    listingsArray = listingsArray.sort(
      (a, b) => b["completionScore"] - a["completionScore"]
    );
    let top5 = [];
    if (sponsorListings != null && sponsorListings.length > 0) {
      sponsorListings.forEach((listing) => {
        let fulllisting = listingsArray.find(
          (element) => element.strapi_id === listing.strapi_id
        );
        if (fulllisting !== undefined) {
          fulllisting["sponsored"] = true;
          top5.push(fulllisting);
          const index = listingsArray.indexOf(fulllisting);
          if (index > -1) {
            // only splice array when item is found
            listingsArray.splice(index, 1);
          }
        } else {
          listing["completionScore"] = 100000;
          top5.push(listing);
        }
      });
      top5 = top5.sort((a, b) => b["completionScore"] - a["completionScore"]);
      top5 = top5.concat(listingsArray);
      top5 = top5.slice(0, 5);
    } else {
      top5 = listingsArray.slice(0, 5);
    }
    return top5;
  }

  return (
    <>
      {relatedListings != null && relatedListings.length > 0 ? (
        <>
          <Typography
            variant="h2Side"
            sx={{
              mt: 5,
              ml: 4,
              mr: 4,
              mb: 3,
              color: "#606C7F",
              fontSize: "1.6rem",
              textAlign: "center",
              display: "block",
              font: "Raleway",
            }}
          >
            Related Products
          </Typography>
          <Script>
            {isBrowser ? window.dataLayer.push({ ecommerce: null }) : ""}
          </Script>
          <Script>
            {isBrowser
              ? window.dataLayer.push({
                  event: "view_item_list",
                  ecommerce: {
                    items: alalyticsProds,
                  },
                })
              : ""}
          </Script>
          <Script>
            {isBrowser ? window.dataLayer.push({ ecommerce: null }) : ""}
          </Script>
          <Script>
            {isBrowser && analPromos && analPromos.length > 0
              ? window.dataLayer.push({
                  event: "promoView",
                  ecommerce: {
                    items: alalyticsPromos,
                  },
                })
              : ""}
          </Script>
        </>
      ) : (
        ""
      )}
      {relatedListings.map((listing, index) => (
        <Card
          sx={{
            cursor: "pointer",
            maxHeight: 86,
            width: "100%",
            mt: 2,
            borderRadius: 5,
          }}
          data-productid={"P" + listing.strapi_id}
          data-testid={
            listing.sponsored
              ? "librarySponsoredSide" + index
              : "libraryProdSide" + index
          }
        >
          {listing.sponsored ? (
            <>
              <Divider
                sx={{ borderBottomWidth: 3 }}
                style={{ background: "gold" }}
              ></Divider>
            </>
          ) : (
            ""
          )}
          <Link
            id={
              listing.sponsored
                ? "librarySponsoredSide" + index
                : "libraryProdSide" + index
            }
            to={listing.path}
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={(e) => {
              if (isBrowser) {
                window.dataLayer.push({ ecommerce: null });
                if (listing.sponsored) {
                  window.dataLayer.push({
                    event: "promotionClick",
                    ecommerce: {
                      items: [
                        {
                          item_id: "P" + listing.strapi_id, // unique identifier for a product apart from the name
                          item_name: listing.name, //Name of the vendor
                          item_category: strapiArticle.title, //What is the category page where this impressions loads
                          item_list_name: "Article", //What is the list where the impression got registered
                          index: index, //what is the position of that vendor on that list
                          productIndex: index,
                          brand: listing.companyName, //Name of the brand
                        },
                      ],
                    },
                  });
                } else {
                  window.dataLayer.push({
                    event: "productClick",
                    ecommerce: {
                      items: [
                        {
                          item_id: "P" + listing.strapi_id, // unique identifier for a product apart from the name
                          item_name: listing.name, //Name of the vendor
                          item_category: strapiArticle.title, //What is the category page where this impressions loads
                          item_list_name: "Article", //What is the list where the impression got registered
                          index: index, //what is the position of that vendor on that list
                          productIndex: index,
                          brand: listing.companyName, //Name of the brand
                        },
                      ],
                    },
                  });
                }
              }
            }}
          >
            <Grid
              item
              container
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              rowSpacing={0}
            >
              <Grid item sm={3.5}>
                <img
                  src={
                    listing.productLogo
                      ? generalUtil._cleanPortalURL(listing.productLogo.url)
                      : generalUtil._cleanImages(listing.productLogoURL)
                  }
                  alt={listing.name + "Profile Image"}
                  style={{
                    zIndex: 2,
                    marginBottom: 0,
                    backgroundColor: "white",
                    width: 86,
                    height: 86,
                    objectFit: "fill",
                  }}
                />
              </Grid>
              <Grid
                item
                container
                direction="column"
                sm={7.5}
                sx={{
                  ml: 1,
                }}
              >
                <Grid item>
                  <Typography variant="h5ProductListing">
                    {listing.name}
                  </Typography>
                </Grid>
                {listing.overallRating ? (
                  <Grid item>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Rating
                        name="read-only"
                        value={listing.overallRating}
                        readOnly
                        precision={0.5}
                        size="small"
                      />
                      <Typography variant="h8b">
                        ({listing.numberOfReviews})
                      </Typography>
                    </div>
                  </Grid>
                ) : (
                  ""
                )}
                {listing.sponsored ? (
                  <Grid
                    item
                    container
                    alignItems="flex-end"
                    justifyContent="flex-end"
                  >
                    <Grid item>
                      <Typography
                        variant="h8"
                        sx={{
                          textAlign: "right",
                          fontSize: ".6rem",
                          mb: -4,
                          p: -4,
                        }}
                      >
                        Sponsored
                      </Typography>
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Link>
        </Card>
      ))}
    </>
  );
};
export default RelatedProducts;
